// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

var mySwiper = new Swiper('.quote-slider', {

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

})
